//======> Docementation <======//
registerBlockType('tornado/landing-text', {
    title: __('landing text ', 'tornado'),
    description: __('landing text ', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
        section_title : {
            type: 'string',
            selector: '.title',
            default: 'نبذه عن',
        },
        section_description : {
            type: 'string',
            selector: '.desc1',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        checklist : {
            type: 'array',
            source: 'children',
            multiline: 'ul',
            selector: '.checlist',
            default: [
                'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
                'لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل',
                'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
                'لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل',
            ],
        },
        section_image : {
            type: 'string',
            default: 'https://via.placeholder.com/570x320',
        },
     
        description_control : {
            type: 'string',
            default : 'enable',
        },
        list_control : {
            type: 'string',
            default : 'disable',
        },
       
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        const set_section_title = section_title => { setAttributes({section_title}) };
        const set_section_description = section_description => { setAttributes({section_description}) };
        const set_checklist = checklist => { setAttributes({checklist}) };
        const set_description_control = description_control => { setAttributes({description_control}) };
        const set_list_control = list_control => { setAttributes({list_control}) };
        //==== Images and icons Uploader ====//
        const section_image = (openEvent) => {
            return(<img src={ attributes.section_image } alt={ attributes.section_title2 } onClick={ openEvent }/>)
        };
        //==== Block Structure ====//
        return (
            <Panel>
                <PanelBody>
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                            {/* //=== Background Color Class ===// */}
                            <SelectControl key="description-control" label="اظهار / اخفاء الوصف" value={ attributes.description_control }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_description_control}
                                />
                            <SelectControl key="list-control" label="اظهار / اخفاء القائمة" value={ attributes.list_control }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_list_control}
                            />
                           
                            <MediaUpload render={({open}) => section_image(open)} value={ attributes.section_image }  onSelect={media => { setAttributes({section_image: media.url}); }} type="image" />
                           
                        </PanelBody>
                    </InspectorControls>
                    <div className="section-medium hero-section">
                        <div className="container">
                            <div className="row align-center-y content large overflow">
                                <div className="col-12 col-m-5 col-l-6">
                                    <img src={attributes.section_image} alt={attributes.section_title}/>
                                </div>
                                <div className="col-12 col-m-7 col-l-6 view-status" data-animation="fadeInEnd">
                                    <RichText tagName="h3" className="mb15" onChange={ set_section_title } value={attributes.section_title} />
                                    {attributes.description_control === 'enable' &&
                                    <RichText tagName="p" onChange={ set_section_description } value={attributes.section_description}/>}
                                    {attributes.list_control === 'enable' &&
                                    <RichText tagName="ul" className="checklist arrow-icons checlist" multiline="li" placeholder={ __( 'محتوي على شكل قائمة', 'tornado' ) } onChange={ set_checklist } value={ attributes.checklist } />}
                                </div>
                            </div>
                        </div>
                    </div>
            
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
            <div className="section-medium hero-section">
                <div className="container">
                    <div className="row align-center-y content large overflow">
                        <div className="col-12 col-m-5 col-l-6">
                            <img src={attributes.section_image} alt={attributes.section_title}/>
                        </div>
                        <div className="col-12 col-m-7 col-l-6 view-status" data-animation="fadeInEnd">
                            <h3 className="mb15">{attributes.section_title}</h3>
                            {attributes.description_control === 'enable' &&
                            <p>{attributes.section_description}</p>}
                            {attributes.list_control === 'enable' &&
                            <ul className="checklist arrow-icons checlist">{attributes.checklist}</ul>}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});